<template>
  <div class="page">
    <div class="page-title">編輯推廣碼</div>
    <div class="page-box">
    <promoteFrom :form="form" ref="form"></promoteFrom>
    <div class="page-button">
      <el-button type="info" @click="onSubmit">提交</el-button>
      <el-button type="success" @click="onBack">取消</el-button>
    </div>
    </div>
  </div>
</template>

<script>
import {getPromotionCodesDetail,putPromotionCodes} from '@/api/order'
import promoteFrom from "./components/promoteFrom.vue";
export default {
  components: { promoteFrom },
   props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        code: null,
        description: null,
        discount: null,
      },
    };
  },
  created(){
    this.getPromotionCodesDetail()
  },
  methods: {
    onSubmit() {
      this.$refs.form.$refs.form.validate((valid) => {
        if (valid) {
          this.putPromotionCodes();
        }
      });
    },
    getPromotionCodesDetail(){
      getPromotionCodesDetail(this.id).then((res) => {
        this.form = res.data;
      });
    },
    putPromotionCodes() {
      putPromotionCodes(this.id,this.form).then(() => {
        this.$message({
          message: "修改成功",
          type: "success",
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-button {
  margin-top: 20px;
}
.page-box {
  background-color: #fff;
  padding: 20px;
    margin: 20px 0;
}
</style>